<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="申述类型" prop="type">
                <a-select v-model="queryParam.type" placeholder="请选择申述类型" allow-clear>
                  <a-select-option v-for="(d, index) in dict.type['order_appeal_type']" :key="index" :value="d.value">{{ d.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 状态页签 -->
      <a-tabs v-model="statusTab" class="order-appeal-tabs" @change="onStatusTabChange">
        <a-tab-pane key="pending" tab="待审核/待处理" />
        <a-tab-pane key="completed" tab="已处理" />
        <a-tab-pane key="rejected" tab="审核不通过" />
      </a-tabs>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />
      <!-- 处置弹窗 -->
      <handle-modal
        :visible="handleModalVisible"
        :record="currentHandleRecord"
        @update:visible="onHandleModalVisibleChange"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="userNickname" slot-scope="text, record">
          {{ record.userNickname || '-' }}
        </span>
        <span slot="userContact" slot-scope="text, record">
          {{ record.userContact || '-' }}
        </span>
        <span slot="orderTitle" slot-scope="text, record">
          {{ record.orderTitle || '-' }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="type" slot-scope="text">
          <dict-tag :options="dict.type['order_appeal_type']" :value="text !== undefined && text !== null ? String(text) : ''" />
        </span>
        <span slot="status" slot-scope="text">
          {{ statusMap[text] != null ? statusMap[text] : '未知' }}
        </span>
        <span slot="handleType" slot-scope="text">
          {{ handleTypeMap[text] || '未知' }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['orderAppeal:orderAppeal:edit']">
            <a-icon type="edit" />审核
          </a>
          <a-divider v-if="record.status === 1 || record.status === 2" type="vertical" v-hasPermi="['orderAppeal:orderAppeal:remove']" />
          <a v-if="record.status === 1 || record.status === 2" @click="openHandleModal(record)" v-hasPermi="['orderAppeal:orderAppeal:edit']">
            <a-icon type="edit" />处置
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageOrderAppeal, delOrderAppeal } from '@/api/orderAppeal/orderAppeal'
import CreateForm from './modules/CreateForm'
import HandleModal from './modules/HandleModal'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'OrderAppeal',
  components: {
    CreateForm,
    HandleModal
  },
  mixins: [tableMixin],
  dicts: ['order_appeal_type'],
  data() {
    return {
      statusTab: 'pending',
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        userId: null,
        orderId: null,
        type: undefined,
        status: undefined,
        statusList: undefined,
        handleType: undefined,
        pageNum: 1,
        pageSize: 10
      },
      statusMap: { 0: '待审核', 1: '待处理', 2: '已处理', 3: '审核不通过' },
      handleTypeMap: {},
      handleModalVisible: false,
      currentHandleRecord: null,
      columns: [
        {
          title: '用户昵称',
          dataIndex: 'userNickname',
          scopedSlots: { customRender: 'userNickname' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '联系方式',
          dataIndex: 'userContact',
          scopedSlots: { customRender: 'userContact' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '订单标题',
          dataIndex: 'orderTitle',
          scopedSlots: { customRender: 'orderTitle' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          width: 180,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '申述类型',
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '申述描述',
          dataIndex: 'appealDescription',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '处理类型',
          dataIndex: 'handleType',
          scopedSlots: { customRender: 'handleType' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '扣分',
          dataIndex: 'deductionScore',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '限制接单天数',
          dataIndex: 'day',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '提交时间',
          dataIndex: 'createTime',
          width: 160,
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 150,
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created() {
    this.applyStatusByTab()
    this.getList()
  },
  methods: {
    applyStatusByTab() {
      if (this.statusTab === 'pending') {
        this.queryParam.status = undefined
        this.queryParam.statusList = [0, 1]
      } else if (this.statusTab === 'completed') {
        this.queryParam.status = 2
        this.queryParam.statusList = undefined
      } else if (this.statusTab === 'rejected') {
        this.queryParam.status = 3
        this.queryParam.statusList = undefined
      }
    },
    onStatusTabChange() {
      this.queryParam.pageNum = 1
      this.applyStatusByTab()
      this.getList()
    },
    getList() {
      this.applyStatusByTab()
      this.loading = true
      const param = { ...this.queryParam }
      if (param.statusList && param.statusList.length === 0) param.statusList = undefined
      pageOrderAppeal(param).then(response => {
        const data = response.data || response
        this.list = data.records || []
        this.total = data.total != null ? data.total : 0
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.statusTab = 'pending'
      this.queryParam = {
        userId: undefined,
        orderId: undefined,
        type: undefined,
        status: undefined,
        statusList: [0, 1],
        handleType: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    openHandleModal(record) {
      this.currentHandleRecord = record
      this.handleModalVisible = true
    },
    onHandleModalVisibleChange(val) {
      this.handleModalVisible = val
      if (!val) this.currentHandleRecord = null
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleDelete(row) {
      const that = this
      if (row && row.id) {
        that.ids = [row.id]
      }
      const ids = that.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          const data = that.ids.map(id => ({ id }))
          return delOrderAppeal(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          that.ids = []
        }
      })
    },
    handleExport() {
      const that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download('order-appeal/order-appeal/export', {
            ...that.queryParam
          }, `订单申述_${new Date().getTime()}.xlsx`)
        },
        onCancel() {}
      })
    }
  }
}
</script>

<style lang="less" scoped>
.order-appeal-tabs {
  margin-bottom: 16px;
}
</style>
